// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const flamigo: PokeData = {
  "id": 973,
  "name": "flamigo",
  "height": 16,
  "weight": 370,
  "base_experience": 175,
  "types": [
    PokeType.FLYING,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "wing-attack",
    "double-kick",
    "mega-kick",
    "peck",
    "low-kick",
    "focus-energy",
    "detect",
    "roost",
    "feint",
    "payback",
    "copycat",
    "air-slash",
    "brave-bird",
    "wide-guard",
    "throat-chop"
  ],
  "moves": [
    "double-kick",
    "peck",
    "roost",
    "air-slash",
    "brave-bird",
    "sky-attack",
    "gust",
    "close-combat",
    "bulk-up",
    "meteor-assault",
    "jump-kick",
    "karate-chop",
    "drain-punch"
  ],
  "evolution_chain": {
    "id": 510,
    "item": null,
    "species": [
      {
        "name": "flamigo",
        "order": 961,
        "types": [
          PokeType.FLYING,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 128,
    "ability_power": 164
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
